export default class WhitelistModel {
    public whitelistID = "";
    public userC5Email = "";
    public userC5ID = "";

    public static  toModelList(obj: any): WhitelistModel[] {
        return obj.map((item: any) => {
            return {
                whitelistID: item.whitelistID,
                userC5Email: item.userC5Email,
                userC5ID: item.userC5ID,
            } as WhitelistModel;
        });
    } 
}